import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Mail, Lock, LogIn } from 'lucide-react';
import './Login.css';
import { API_URL } from '../../api';
import logoNorac from '../../assets/img/logo_norac.png';

export async function loginApi(email, senha) {
  const response = await fetch(`${API_URL}/login`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ email, senha }),
  });

  let data;
  try {
    data = await response.json();
  } catch (e) {
    throw new Error('Login inválido. Verifique seu e-mail e senha.');
  }

  if (!response.ok) {
    throw new Error(data.mensagem || 'Login inválido. Verifique seu e-mail e senha.');
  }

  return data;
}

function Login() {
  const [email, setEmail] = useState('vendedor1@krivosistemas.com.br'); // TEMPORÁRIO: Preenchimento automático para desenvolvimento
  const [senha, setSenha] = useState('123456'); // TEMPORÁRIO: Preenchimento automático para desenvolvimento
  const [erro, setErro] = useState('');
  const [sucesso, setSucesso] = useState('');
  const [carregando, setCarregando] = useState(false);
  const [mostrarSenha, setMostrarSenha] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      navigate('/dashboard', { replace: true });
    }
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setErro('');
    setSucesso('');
    if (email.trim() === '' || senha.trim() === '') {
      setErro('Por favor, preencha todos os campos.');
      return;
    }
    setCarregando(true);
    try {
      const resposta = await loginApi(email, senha);
      setSucesso('Login realizado com sucesso!');
      localStorage.setItem('token', resposta.token);
      localStorage.setItem('nome_usuario', resposta.usuario.nome);
      localStorage.setItem('email_usuario', resposta.usuario.email);
      setTimeout(() => {
        navigate('/dashboard');
      }, 800);
    } catch (err) {
      console.log('erro:', err);
      if (err instanceof TypeError && err.message && err.message.includes('Failed to fetch')) {
        setErro('Não foi possível conectar ao servidor. Verifique sua conexão ou tente novamente mais tarde.');
      } else {
        setErro(err.message);
      }
    } finally {
      setCarregando(false);
    }
  };

  return (
    <div className="login-bg">
      <div className="login-container">
        <div className="login-logo-top">
          <img src={logoNorac} alt="Logo Norca Alimentos" className="login-logo-img" />
        </div>
        
        <div className="login-subtitle">Sistema de Pedidos</div>
        <form className="login-form" onSubmit={handleLogin}>
          <div className="login-field">
            <label htmlFor="email">Email</label>
            <div className="login-input-wrapper">
              <Mail size={18} className="login-input-icon" />
              <input
                id="email"
                type="email"
                //value={email}
                value=''
                onChange={e => setEmail(e.target.value)}
                placeholder="vendedor@noracfoods.com.br"
                autoComplete="username"
              />
            </div>
          </div>
          <div className="login-field">
            <label htmlFor="senha">Senha</label>
            <div className="login-input-wrapper">
              <Lock size={18} className="login-input-icon" />
              <input
                id="senha"
                type={mostrarSenha ? 'text' : 'password'}
                //value={senha}
                onChange={e => setSenha(e.target.value)}
                placeholder="********"
                autoComplete="current-password"
              />
              <button
                type="button"
                className="login-eye-btn"
                tabIndex={-1}
                onClick={() => setMostrarSenha((v) => !v)}
                aria-label={mostrarSenha ? 'Ocultar senha' : 'Mostrar senha'}
              >
                <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  {mostrarSenha ? (
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-5.523 0-10-4.477-10-10 0-1.657.336-3.236.938-4.675M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                  ) : (
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0zm7.938-2.675A9.956 9.956 0 0022 12c0 5.523-4.477 10-10 10a9.956 9.956 0 01-4.675-.938M3.98 8.98A9.956 9.956 0 002 12c0 5.523 4.477 10 10 10a9.956 9.956 0 004.675-.938" />
                  )}
                </svg>
              </button>
            </div>
          </div>
          {erro && <div className="erro">{erro}</div>}
          {sucesso && <div className="sucesso">{sucesso}</div>}
          <button type="submit" className="login-btn" disabled={carregando}>
            <span className="login-btn-icon"><LogIn size={20} /></span>
            {carregando ? 'Entrando...' : 'Entrar'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login;